import axios from "../axiosInstance";

class CustomerTypeService {
  async listCustomerTypes() {
    return await axios.get("customertype");
  }
}

export default new CustomerTypeService();
